export enum ActivityLogTargetTypeEnum {
  // File and Folder Targets
  File = 'File', // File
  Folder = 'Folder', // Folder
  Files = 'Files', // Files
  FilesAndFolders = 'FilesAndFolders', // File and Folder
  FilesAndTags = 'FilesAndTags', // File and Tags
  FilesFoldersAndTags = 'FilesFoldersAndTags', // File, Folder and Tags
  // User and Group Targets
  User = 'User', // User
  Group = 'Group', // Group
  // Sharing Targets
  Share = 'Share', // Share entry
  ShareLink = 'ShareLink', // Share link
  // Version Control
  Version = 'Version', // Version of a file or document
  // Collaboration and Communication
  Comment = 'Comment', // Comment on a document or file
  Task = 'Task', // Task assigned in a collaborative environment
  // Permissions and Access Control
  Permission = 'Permission', // Permission
  AccessControl = 'AccessControl', // Access control entries
  // Admin Operations
  Admin = 'Admin', // Admin-related operations
  Configuration = 'Configuration', // System configuration
  Setting = 'Setting', // Individual setting
  // Miscellaneous
  Tag = 'Tag', // Tag or label
  Metadata = 'Metadata', // Metadata entry
  Notification = 'Notification', // Notification entry
  Workflow = 'Workflow', // Workflow or process definition
  Template = 'Template', // Template for documents or files
  AuditLog = 'AuditLog',
  // Security and Monitoring
  Security = 'Security', // Security-related targets
  Monitoring = 'Monitoring', // Monitoring and logging targets
  // Authentication
  Authentication = 'Authentication', // Authentication-related targets
  TwoFactorAuth = 'TwoFactorAuth', // Two-factor authentication targets
  // Encryption
  Encryption = 'Encryption', // Encryption-related targets
  EncryptionKey = 'EncryptionKey', // Encryption key management
  // Other
  Other = 'Other', // Other generic targets
}
